import React from "react";
import {FC} from "react";
import DtoTable from "../../components/dto-table/dto-table";
import CargoListModel from "../../models/dto/cargo-list-model";
import useSafeState from "../../utils/safe-state";
import {Breadcrumb, Tooltip, Button, message, notification, Popconfirm, Divider, Upload} from "antd";
import {Trans} from "@lingui/macro";



import {
    FileOutlined,
    QrcodeOutlined,
    FileAddOutlined, DeleteTwoTone, EditOutlined, EditTwoTone, DownloadOutlined, UploadOutlined,

} from "@ant-design/icons/lib";

import {PlusOutlined} from "@ant-design/icons/lib";
import Drawer from "../../components/drawer/drawer";
import UploadedFilesDrawer from "../../forms/cargo-form/uploaded-files-drawer";
import UploadFilesDrawer from "../../forms/cargo-form/upload-files-drawer";
import NewCargoDrawer from "../../forms/cargo-form/new-cargo-drawer";
import LabelPrintDrawer from "../../forms/cargo-form/label-print-drawer";
import { AxiosResponse, AxiosError } from 'axios';
import {useAxios} from "../../utils/hooks";
import {antdContext} from "../../utils/antdContext";
import { openNotification } from '../../utils/openNotification';
import ButtonWithIcon from "../../components/buttons/button-with-icon";
import {LeftCircleTwoTone, RightCircleTwoTone} from "@ant-design/icons";




const CargoListScreen : FC = () => {

    const axiosInstance = useAxios(process.env.REACT_APP_API_BASE_URL + "");
    const [loading, setLoading] = useSafeState(false);
    const [xlsLoading, setXlsLoading] = useSafeState(false);
    const [xlsxUploadLoading, setXlsxUploadLoading] = useSafeState(false);
    const [trigger, setTrigger] = useSafeState(false);
    const uploadedFilesText = <Trans>Cargo uploaded files list</Trans>
    const uploadFilesText = <Trans>Cargo upload files</Trans>
    const labelPrintText = <Trans>Label print</Trans>
    const cargoText = <Trans>New Cargo</Trans>

    const newCargoDrawer = Drawer(
        {
            title: cargoText,
            children:
                <NewCargoDrawer/>,
            customClose: () => setTrigger(!trigger)
        }
    );

    const uploadedFilesDrawer = Drawer(
        {
            title: uploadedFilesText,
            children:
                <UploadedFilesDrawer/>,
            customClose: () => setTrigger(!trigger)
        }
    );


    const labelPrintDrawer = Drawer(
        {
            title: labelPrintText,
            children:
                <LabelPrintDrawer/>,
            customClose: () => setTrigger(!trigger)
        }
    );


    const uploadFilesDrawer = Drawer(
        {
            title: uploadFilesText,
            children:
                <UploadFilesDrawer/>,
            customClose: () => setTrigger(!trigger)
        }
    );

    const deleteRecord = (record: any) => {
        if(axiosInstance.current != null) {
            setLoading(true);
            const rollNumber = record.rollNumber;
            axiosInstance.current.delete("/resource/stock/deleterecord?rollNumber=" + encodeURIComponent(rollNumber), {})
                .then(function (response : AxiosResponse<any>) {
                    setLoading(false);
                    message.success(antdContext('Az adott sor sikeresen törölve lett.'));
                    setTrigger(false);
                    setTrigger(!trigger);
                }).catch(function (error :AxiosError) {
                    setLoading(false);
                    const errMessage = error && error.response && error.response.data && error.response.data.message
                        ? error.response.data.message
                        : 'Delete failed';
                    openNotification('error', errMessage);
                    console.log(error);
            });
        }
    }

    const heldBackRecord = (record: any) => {
        if(axiosInstance.current != null) {
            setLoading(true);
            axiosInstance.current.put("/resource/cargo/heldbackrecord?id=" + record.id, {})
                .then(function (response : AxiosResponse<any>) {
                    setLoading(false);
                    message.success(antdContext('Az adott sor sikeresen mentve.'));
                    setTrigger(false);
                    setTrigger(!trigger);
                }).catch(function (error :AxiosError) {
                let errResp = JSON.parse(JSON.stringify(error.response));
                let errMessage = errResp.data.message;
                openNotification('error',errMessage);
                console.log(error)
                setLoading(false);
            });
        }
    }

    const freeFromHeldBackRecord = (record: any) => {
        if(axiosInstance.current != null) {
            setLoading(true);
            axiosInstance.current.put("/resource/cargo/freeheldbackrecord?id=" + record.id, {})
                .then(function (response : AxiosResponse<any>) {
                    setLoading(false);
                    message.success(antdContext('Az adott sor sikeresen mentve.'));
                    setTrigger(false);
                    setTrigger(!trigger);
                }).catch(function (error :AxiosError) {
                let errResp = JSON.parse(JSON.stringify(error.response));
                let errMessage = errResp.data.message;
                openNotification('error',errMessage);
                console.log(error)
                setLoading(false);
            });
        }
    }

    const action =  (record: any) => {

            return (
            <>
                <Tooltip  title={<Trans>Edit</Trans>}>
                    <EditTwoTone
                        twoToneColor={"#40a9ff"}
                        className={"ActionButtons"} onClick={
                        () => newCargoDrawer.open("Edit", {
                            data: {
                                rollNumber: record.rollNumber,
                                deliveryNoteNumber: record.deliveryNoteNumber,
                                itemNo: record.item.itemNo,
                                fifoNumber: record.item.fifoNumber,
                                supplier: record.supplier.id,
                                weight: record.weight,
                                status: record.status,
                                remark: record.remark,
                                version: record.version,
                            },
                            mode: 'Edit'
                        })}/>

                </Tooltip>
                {/*<Tooltip  title={<Trans>Label print</Trans>}>*/}
                {/*    <QrcodeOutlined*/}
                {/*        disabled={record.status != 'CLOSED' && record.status != 'UIDPRINTED'}*/}
                {/*        className={"ActionButtons"}*/}
                {/*        style={{color: (record.status == 'CLOSED' || record.status == 'UIDPRINTED') ? "#40a9ff" : "gray"}}*/}
                {/*        onClick={() => labelPrintDrawer.open("", {cargoData: record})}/>*/}
                {/*</Tooltip>*/}
                {/*<Tooltip  title={<Trans>Download files</Trans>}>*/}
                {/*    <FileOutlined  className={"ActionButtons"} style={{color: "#40a9ff"}} onClick={()=>uploadedFilesDrawer.open("", {cargoData: record})}/>*/}
                {/*</Tooltip>*/}
                {/*<Tooltip  title={<Trans>Upload files</Trans>}>*/}
                {/*    <FileAddOutlined disabled={*/}
                {/*        record.status != 'CLOSED'*/}
                {/*    } className={"ActionButtons"}*/}
                {/*                     style={{color: "#40a9ff"}} onClick={() => uploadFilesDrawer.open("", {cargoData: record})} />*/}
                {/*</Tooltip>*/}
                {/*<Tooltip  title={<Trans>Held Back</Trans>}>*/}
                {/*    <Popconfirm*/}
                {/*        disabled={record.status == 'DELIVERED' || record.status == 'HELD_BACK'}*/}
                {/*                title={record.status != 'DELIVERED' && record.status != 'HELD_BACK' ? <Trans>Are you sure want to held back this record?</Trans>:<Trans>Delivered record cannot be held back</Trans>}*/}
                {/*                 onConfirm={() => record.status != 'DELIVERED' && record.status != 'HELD_BACK' ? heldBackRecord(record) : ""}*/}
                {/*                 okText={<Trans>Yes</Trans>}*/}
                {/*                 cancelText={<Trans>No</Trans>}>*/}
                {/*        <LeftCircleTwoTone disabled={record.status != 'DELIVERED' && record.status != 'HELD_BACK' } className={"ActionButtons"} twoToneColor={record.status != 'DELIVERED' && record.status != 'HELD_BACK' ? "red" : "gray"}/>*/}
                {/*    </Popconfirm>*/}
                {/*</Tooltip>*/}
                {/*<Tooltip  title={<Trans>Free From Held Back</Trans>}>*/}
                {/*    <Popconfirm disabled={record.status != 'HELD_BACK'}  title={record.status == 'HELD_BACK' ? <Trans>Are you sure want to Free from held back this record?</Trans>:<Trans>Delivered record cannot be free from held back</Trans>}*/}
                {/*                 onConfirm={() => record.status == 'HELD_BACK' ? freeFromHeldBackRecord(record) : ""}*/}
                {/*                 okText={<Trans>Yes</Trans>}*/}
                {/*                 cancelText={<Trans>No</Trans>}>*/}
                {/*        <RightCircleTwoTone disabled={record.status == 'HELD_BACK' } className={"ActionButtons"} twoToneColor={record.status == 'HELD_BACK' ? "blue" : "gray"}/>*/}
                {/*    </Popconfirm>*/}
                {/*</Tooltip>*/}

                <Tooltip  title={<Trans>Remove</Trans>}>
                    <Popconfirm  title={record.status != 'DELIVERED' ? <Trans>Are you sure want to delete record?</Trans>:<Trans>Delivered record cannot be deleted</Trans>}
                            onConfirm={() => record.status != 'DELIVERED' ? deleteRecord(record) : ""}
                            okText={<Trans>Yes</Trans>}
                            cancelText={<Trans>No</Trans>}> 
                        <DeleteTwoTone disabled={record.status != 'DELIVERED'} className={"ActionButtons"} twoToneColor={record.status != 'DELIVERED' ? "red" : "gray"}/>
                    </Popconfirm>

                </Tooltip>

            </>
    )};

    const actions = {
        width: 100,
        render: (text: string, record: any) => action(record),
        title: '',
        fixed: 'right',
        align: 'center'
    };


    const handleDownloadXls = () => {
        setXlsLoading(true);
        if (axiosInstance.current != null) {
            const FileDownload = require('js-file-download');
            let lang = localStorage.getItem('language') ? localStorage.getItem('language') : 'hu';
            axiosInstance
                .current({
                    url: process.env.REACT_APP_API_BASE_URL + '/resource/cargo/' + lang + '/xls/',
                    method: 'POST',
                    responseType: 'blob',
                })
                .then(response => {
                    FileDownload(response.data, 'cargo_list.xls');
                })
                .finally(() => setXlsLoading(false));
        }
    };

    const xlsxUploadProps = {
        beforeUpload: (file: any) => {
            const isXlsx = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            if (!isXlsx) {
                openNotification('customError', 'Only XLSX files are supported');
                return false;
            }

            if (axiosInstance.current != null) {
                setXlsxUploadLoading(true);
                const formData = new FormData();
                formData.append('file', file);

                axiosInstance.current
                    .post('/resource/stock/upload-incoming', formData, {
                        headers: { 'Content-Type': 'multipart/form-data' },
                    })
                    .then((response: AxiosResponse<any>) => {
                        const { createdCount, errors } = response.data;
                        setTrigger(!trigger);
                        setXlsxUploadLoading(false);
                        openNotification('customSuccess', `${createdCount} tekercs sikeresen felvéve.`);
                        if (errors && errors.length > 0) {
                            notification.warning({
                                message: <b>{antdContext('Hibás sorok')}</b>,
                                description: <>{errors.map((err: string, idx: number) => <div key={idx}>{err}</div>)}</>,
                                placement: 'topRight',
                                duration: 0
                            });
                        }
                    })
                    .catch(function (error: any) {
                        const message = error && error.response && error.response.data && error.response.data.message
                            ? error.response.data.message
                            : 'Upload failed';
                        openNotification('error', message);
                        setXlsxUploadLoading(false);
                    });
            }

            return false;
        },
        showUploadList: false,
    };

    const header = (
        <>
            <Button type={"primary"} onClick={()=>newCargoDrawer.open("", {
                mode: 'AddNew'
            })
            } style={{float: "left", marginRight:10}}><PlusOutlined /><span><Trans>Add new cargo</Trans></span>
            </Button>
            <Upload {...xlsxUploadProps} accept=".xlsx" className="custom-upload" style={{ float: 'left'}}>
                <Button loading={xlsxUploadLoading} style={{ float: 'left', marginRight: 10 }}>
                    <ButtonWithIcon icon={<UploadOutlined />} text={<Trans>Xlsx feltöltés</Trans>} />
                </Button>
            </Upload>
        </>
    );


    return (<>
    
        <>
        
            <Breadcrumb style={{ marginBottom: 10 }}>
                <Breadcrumb.Item><Trans id={'Homepage'}/></Breadcrumb.Item>
                <Breadcrumb.Item><Trans>Material delivery list</Trans></Breadcrumb.Item>
            </Breadcrumb>
            <DtoTable
                tableHeader={header}
                model={CargoListModel}
                action={actions}
                apiUrl={"cargo"}
                trigger={trigger}
                allowExport={false}
                allowRefreshButton={true}
                pageSize={100}
                scroll={{ x: 1300, y: "65vh" }}
                />
                {uploadedFilesDrawer.component}
                {labelPrintDrawer.component}
                {uploadFilesDrawer.component}
                {newCargoDrawer.component}
                </>
        
    
    </>
)
}
export default CargoListScreen;
